import { ExcelColumn } from '../../../../../../../generic/hooks/useExportToExcel'
import { IReportQ8Response } from '../../../../../../../modules/API/Reports/models/q8'

export const q8ExcelColumns: ExcelColumn<IReportQ8Response>[] = [
  { header: 'לקוח', accessor: (item) => item.ClientName?.trim() ?? '' },
  { header: 'פריט', accessor: (item) => item.Description?.trim() ?? '' },
  { header: 'יתרת פתיחה', accessor: (item) => item.QuantityBefore },
  { header: 'חיוב', accessor: (item) => item.QuantityDebit },
  { header: 'זיכוי', accessor: (item) => item.QuantityCredit },
  { header: 'לתקופה', accessor: (item) => item.QuantityPeriod },
  { header: 'יתרת סגירה', accessor: (item) => item.QuantityAfter },
]
